/* Premium Product Card AJAX Add - Dawn
   File: assets/premium-product-card.js */

(function () {
  if (window.PremiumProductCardLoaded) return;
  window.PremiumProductCardLoaded = true;

  async function addVariantToCart(variantId, quantity) {
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity || 1);

    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: formData
    });

    var data = await response.json();

    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Ürün sepete eklenemedi.');
    }

    return data;
  }

  async function refreshCartDrawer() {
    var response = await fetch('/cart?sections=cart-drawer,cart-icon-bubble&sections_url=' + encodeURIComponent(window.location.pathname), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    var sections = await response.json();
    var parser = new DOMParser();

    if (sections['cart-drawer']) {
      var drawerDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      var newDrawer = drawerDoc.querySelector('cart-drawer');
      var currentDrawer = document.querySelector('cart-drawer');

      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
        currentDrawer.classList.remove('is-empty');
      }
    }

    if (sections['cart-icon-bubble']) {
      var bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
      var newBubble = bubbleDoc.querySelector('#cart-icon-bubble');
      var currentBubble = document.querySelector('#cart-icon-bubble');

      if (newBubble && currentBubble) {
        currentBubble.innerHTML = newBubble.innerHTML;
      }
    }
  }

  function openCartDrawer(trigger) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    drawer.classList.remove('is-empty');

    if (typeof drawer.open === 'function') {
      drawer.open(trigger);
    } else {
      drawer.classList.add('active', 'animate');
      document.body.classList.add('overflow-hidden');
    }
  }

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('.premium-product-card__ajax-add');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var variantId = button.getAttribute('data-variant-id');
    var quantity = button.getAttribute('data-quantity') || 1;
    var card = button.closest('[data-premium-product-card]');

    if (!variantId) return;

    if (card) card.classList.add('is-loading');
    button.disabled = true;

    try {
      await addVariantToCart(variantId, quantity);
      await refreshCartDrawer();
      openCartDrawer(button);
    } catch (error) {
      console.error(error);
      alert(error.message || 'Ürün sepete eklenemedi.');
    } finally {
      if (card) card.classList.remove('is-loading');
      button.disabled = false;
    }
  });
})();
